"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "Todos os Cursos",
    "className": "Nome do Workshop",
    "continue": "Continuar",
    "courseChapter": "Capítulo",
    "courseEvaluate": "Avaliação",
    "courseHours": "Crédito",
    "courseInfo": "Detalhe",
    "courseNote": "Notas",
    "coursesCategory": "Categorias do Curso",
    "electiveCourses": "Curso Opcional",
    "pages": "Página",
    "relatedCourses": "Cursos relevantes",
    "requiredCourses": "Aula",
    "searchTips": "Digite o Nome do Curso",
    "studentsNum": "Audiências",
    "teachersDesc": "Professor",
    "newCourse": "Últimos cursos"
  },
  "footer_zlb": {
    "aboutUs": "Sobre Nós",
    "downLoad": "Descarregar APP",
    "qr": "Código QR"
  },
  "global_zlb": {
    "am": "AM",
    "isa": "　",
    "night": "Noite",
    "pm": "PM"
  },
  "header_zlb": {
    "accoutPw": "Passe da Conta",
    "curDis": "Em andamento",
    "curUser": "Utilizador Actual",
    "edit": "Actualizar",
    "helpCenter": "Centro de Ajuda",
    "hisDis": "Histórico",
    "index": "Página Principal",
    "joinStore": "Adicionar aos favoritos",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Mensagem",
    "setIndex": "Definir como pág. principal",
    "userImg": "Foto de Perfil"
  },
  "index_zlb": {
    "discuss": "Workshop",
    "find": "Descobrir",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Eu"
  },
  "info_zlb": {
    "admin": "Administrador",
    "hasAgenda": "Já se juntou à Agenda.",
    "noDown": "Nenhum anexo para descarregar!",
    "pleaseInp": "Digite",
    "submit": "Enviado!",
    "withinTime": "Tarefa ainda não começou",
    "noSubmitWork": "Tarefa não enviada"
  },
  "login_zlb": {
    "accountLogin": "Iniciar sessão",
    "accountNotEmpty": "Conta deve ser preenchida",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Cancelar",
    "captchaNotEmpty": "Código de verificação deve ser preenchido",
    "captchaTips": "Código de verificação incorrecto",
    "changeEmail": "Actualizar Email",
    "changeEmailSuccess": "Endereço de email actualizado.",
    "changeEmailSuccessTips": "O seu email foi actualizado.",
    "Confirm": "Confirmar",
    "currentEmail": "Email Actual",
    "emailCaptcha": "Código de verificação do email",
    "emailCaptchaEmpty": "O código de verificação do email não pode estar vazio",
    "encryEmail": "email de Segurança",
    "error": "Erro de código de verificação",
    "forget": "Esqueci a Palavra Passe",
    "formerEamil": "Email Original",
    "incorrectTips": "Erro de nome de utilizador ou palavra passe",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "Email Novo",
    "newEmailBinded": "O email novo está vinculado à sua conta de utilizador",
    "newEmailEmpty": "Email novo não pode estar vazio",
    "newEmailFomat": "O formato do email novo está incorrecto",
    "newEmailSupport": "Os endereços de Email antigo e novo não são iguais",
    "prevStep": "Último passo",
    "nextStep": "Passo Seguinte",
    "reset": "Redefinir",
    "loginNow": "Iniciar sessão agora",
    "resetSuccess": "Redefinido",
    "resetSuccessTips": "Redefiniu a sua palavra passe. Inicie sessão",
    "msgCaptcha": "Código de verificação SMS",
    "getCaptcha": "Obter código de verificação ",
    "resetPassword": "Redefinir palavra passe",
    "loginFail": "Falha ao iniciar sessão; tente novamente!",
    "failTips": "Falha na Verificação",
    "inputUserName": "Nome de utilizador",
    "goHome": "Ir para pág. principal",
    "passwordFormat": "Palavras passe devem ter 8-32 dígitos e conter números e maiúsculas e minúsculas.",
    "surePasswordEmpty": "Confirmar palavra passe não pode estar vazia",
    "confirmNot": "A palavra passe e confirmar palavra passe são inconsistentes",
    "changePasswordSuccess": "Palavra passe actualizada",
    "continueLogin": "Iniciar sessão novamente",
    "orError": "Utilizador ou palavra passe incorrecto",
    "orgEmailEmpty": "O email original não pode estar vazio",
    "orgEmailFormat": "O formato do email original está incorrecto",
    "orgEmailNot": "O endereço de email original está incorrecto",
    "passWord": "Palavra passe",
    "surePassword": "Confirmar Palavra Passe",
    "passwordBits": "Palavras passe têm de ter pelo meno 6 caracteres",
    "passwordNotEmpty": "Palavra passe deve ser preenchida",
    "pWord": "Palavra passe",
    "sign": "Iniciar sessão",
    "uName": "Conta",
    "userName": "Nome de utilizador",
    "validate": "Código de Verificação",
    "verification": "Conclua a verificação abaixo",
    "appdownload": "Descarregar APP",
    "scancode": "Leia o código QR para transferir",
    "poor": "Fraco",
    "middle": "Médio",
    "strong": "Forte"
  },
  "login": {
    "logout": "Sessão terminada",
    "resetLoginTips": "Alterou a sua palavra passe, tem de iniciar sessão novamente e terminar sessão automaticamente após 3 segundos",
    "sure": "Confirmar",
    "cancel": "Cancelar",
    "captchaNotEmpty": "Código de verificação deve ser preenchido",
    "accountNotEmpty": "Conta deve ser preenchida",
    "passwordNotEmpty": "Palavra passe deve ser preenchida",
    "inputCaptcha": "Código de Verificação",
    "getCaptcha": "Obter código de verificação ",
    "inputOrigPassword": "Digite a palavra passe original",
    "inputNewPassowrd": "Digite uma palavra passe nova",
    "confimPassword": "Confirmar Palavra Passe",
    "changePassword": "Alterar Palavra Passe",
    "nextStep": "Passo Seguinte",
    "resetPassword": "Redefinir palavra passe",
    "resetDone": "Palavra passe redefinida",
    "msgCaptcha": "Código de verificação do email"
  },
  "look_zlb": {
    "aboutLecturer": "Cursos relevantes",
    "benginLearn": "Iniciar Aprendizagem",
    "chapter": "Capítulo",
    "delete": "Apagar",
    "details": "Detalhe",
    "download": "Descarregar",
    "dynamic": "Notícias",
    "evaluation": "Avaliação",
    "hotDyc": "Popular",
    "lecture": "Abrir Curso",
    "lecturer": "Professor",
    "lectureTest": "Categorias do Curso",
    "look": "Descobrir",
    "lookAll": "Ver Tudo",
    "note": "Notas",
    "score": "Pontuação"
  },
  "myMessage_zlb": {
    "passwordError": "Erro de digitação de palavra passe original",
    "aboutUs": "Sobre Nós",
    "allcourse": "Todos os Cursos",
    "atypism": "As duas palavras passe não são iguais",
    "birth": "Data de nascimento",
    "cancel": "Cancelar",
    "carryOut": "Concluído",
    "changePassword": "Alterar Palavra Passe",
    "chineseName": "Nome chinês",
    "chineseNamePlaceholder": "Digite o nome chinês",
    "code": "Código de Verificação",
    "codeError": "Erro de código de verificação",
    "comment": "Comentário",
    "complete": "Concluído",
    "completeUserInfo": "Preencha a informação pessoal",
    "confirm": "Confirmar Palavra Passe",
    "continueStudy": "Continuar",
    "country": "País",
    "countryName": "Nome",
    "countryNamePlaceholder": "Digite o seu nome",
    "countryPlaceholder": "Seleccione um país",
    "courseLearned": "Concluído",
    "delete": "Apagar",
    "documentType": "Tipo de documento de identificação",
    "downloaded": "Transferido",
    "downloading": "A transferir",
    "eduLevel": "Nível de Educação",
    "eduLevelPlaceholder": "Seleccione o nível de educação",
    "email": "Email",
    "emailCode": "Código de verificação do email",
    "gender": "Sexo",
    "genderPlaceholder": "Seleccione sexo",
    "getCode": "Obter código de verificação de email",
    "hasSent": "Enviado",
    "helpCenter": "Centro de Ajuda",
    "hour": "Hora",
    "improveInformation": "Preencha a sua informação pessoal",
    "joinClasses": "Cursos frequentados",
    "joinDis": "Workshops frequentados",
    "learned": "Concluído",
    "learning": "Em progresso ",
    "lecture": "Curso",
    "mailbox": "Email",
    "mailboxValidate": "Verificação de email falhou",
    "man": "Masculino",
    "management": "Definições",
    "minutes": "x horas x minutos",
    "modify": "Actualizar",
    "modifyEmail": "Actualizar Email",
    "my": "Eu",
    "myCertificate": "Meu Certificado",
    "mycourse": "Meu Curso",
    "myDownload": "Minha transferência",
    "myLecture": "Meu Curso",
    "myNotes": "Minha Nota",
    "newMail": "Email Novo",
    "newPassword": "Palavra Passe Nova",
    "nextStep": "Passo Seguinte",
    "orError": "Utilizador ou palavra passe incorrecto",
    "origin": "De",
    "originalPassword": "Palavra Passe Original",
    "password": "Palavra passe",
    "phone": "Número de Telefone",
    "pleChoose": "Seleccione a data de nascimento",
    "post": "Post",
    "postPlaceholder": "Digite post",
    "religion": "Religião",
    "religionPlaceholder": "Escolha religião",
    "retrievePassword": "Recuperar palavra passe",
    "setUp": "Definições",
    "signOut": "Terminar sessão",
    "something": "Gostaria de dizer",
    "submit": "Enviar",
    "sureDelte": "Tem a certeza que deseja apagar?",
    "teacher": "Conferencista",
    "learnYet": "Ainda não começou a aprender",
    "uName": "Nome de utilizador",
    "uNamePlaceholder": "Nome de utilizador",
    "userCenter": "Info pessoal",
    "username": "Nome de utilizador",
    "validateMsg": "Falha na Verificação",
    "woman": "Feminino",
    "learnTo": "Progresso",
    "myRecord": "Meu registo",
    "plePhone": "Digite o número de telefone"
  },
  "notice_zlb": {
    "delete": "Apagar",
    "home": "Página Principal",
    "lettre": "Mensagem privada",
    "lettreEmpty": "Mensagem privada não pode estar vazia",
    "messageDetail": "Detalhes da Mensagem",
    "myMessage": "Minha mensagem",
    "notice": "Aviso",
    "nowBavarder": "Agora pode começar a conversar",
    "send": "Enviar"
  },
  "play_zlb": {
    "networkTip": "Notificação de rede",
    "streamHighTip": "A conexão de rede actual está estável. Alterámos para o modo de alta definição.",
    "streamHighType": "HD",
    "streamNormTip": "A conexão de rede actual está instável. Alterámos para o modo de definição padrão.",
    "streamNormType": "SD",
    "liveTimeDes": "Hora da transmissão ao vivo",
    "livePlayWait": "Transmissão ao vivo não começou",
    "livePlayEnd": "Transmissão ao vivo terminou"
  },
  "questionnaire_zlb": {
    "handed": "Enviar",
    "saveFailed": "Falha ao guardar",
    "examList": "Lista de questões do teste"
  },
  "research_zlb": {
    "afternoon": "PM",
    "all": "Tudo",
    "allCalendar": "Toda a Agenda",
    "alumniBook": "Membro",
    "broadcast": "x iniciar transmissão",
    "carriedout": "Em Progresso",
    "certificate": "Certificado",
    "comment": "Comentário",
    "comments": "Todos os x comentários",
    "courses": "Referência",
    "curDis": "Em andamento",
    "default": "Não iniciado",
    "delete": "Apagar",
    "detail": "Detalhe",
    "discuss": "Fórum",
    "end": "Terminado",
    "endAssess": "Avaliação Terminou",
    "enterAssess": "Iniciar Avaliação",
    "assessButton": "Sugestões",
    "evaluation": "Avaliação",
    "fileAcept": "Tipo de ficheiro errado; carregue novamente.",
    "fileSize10": "O ficheiro seleccionado excede 10m; carregue novamente.",
    "hisDis": "Histórico",
    "lecture": "Referência",
    "live": "Vivo",
    "livebroadcast": "Transmissão ao vivo",
    "minutes": "x minutos atrás",
    "month": "Mês",
    "morning": "AM",
    "noDiscussion": "Sem Workshop",
    "noSchedule": "Sem Agenda",
    "notice": "Aviso",
    "notification": "Sem avisos por ler",
    "offline": "Aula frente a frente",
    "onging": "Em Progresso",
    "online": "Online",
    "operation": "Tarefa",
    "over": "Terminado",
    "participated": "Já Participou ",
    "notParticipate": "Ainda por Participar ",
    "failedCourse": "Não Passou",
    "passedCourse": "Passou",
    "preparation": "Preparação de tarefa",
    "preparations": "Preparação de tarefa",
    "preschoolLecture": "Aula de aquecimento",
    "questionnaire": "Questionário",
    "questionType ": "escolha múltipla (só está correcta 1 respota; marque todas as respostas correctas)",
    "readySay": "Gostaria de dizer",
    "replies": "Tem x respostas novas",
    "save": "Guardar",
    "schedule": "Agenda",
    "searchC": "Pesquisar por tópicos do seu interesse",
    "seeAssess": "Ver Avaliação",
    "submit": "Enviar",
    "submitHomewor": "Cancelar",
    "task": "Tarefa",
    "taskToday": "Tarefa de hoje",
    "video": "Vídeo",
    "week": "Semana",
    "yourcomment": "Escreva o seu comentário",
    "legend": "Legenda",
    "sunday": "Domingo",
    "monday": "Segunda",
    "tuesday": "Terça",
    "wednesday": "Quarta",
    "thursday": "Quinta",
    "friday": "Sexta",
    "saturday": "Sábado",
    "consult": "Materiais de Referência",
    "schedules": "Tarefas",
    "calendar": "Calendário",
    "waitAssesment": "Questionário a ser enviado",
    "year": "Ano",
    "day": "Dia",
    "preview": "Pré-visualizar",
    "resource": "Descarregar"
  },
  "retrieve_zlb": {
    "emailEmpty": "Endereço de email não pode estar vazio.",
    "emailVerif": "Verificação de email "
  },
  "task_zlb": {
    "downF": "Descarregar Anexos",
    "repeatUp": "Carregar novamente",
    "ruY": "Se um dos anexos tiver sido carregado na APP, será substituído se carregar outro no PC.",
    "submitC": "Digite o que deseja enviar",
    "uploadF": "Carregar Anexos"
  },
  "upload_zlb": {
    "clickHere": "clique aqui",
    "limit": "Formato de ficheiro suporta PNG, JPG tamanho não excede",
    "preview": "Pré-visualizar após carregar a imagem",
    "upload": "Carregar"
  },
  "index": {
    "setAsHomePage": "Definir como pág. principal",
    "addCollection": "Adicionar aos favoritos",
    "telephone": "Hotline",
    "Help": "Centro de Ajuda",
    "SystemMessage": "Notificação do sistema",
    "message": "Mensagem privada",
    "emptyMessage": "Limpar",
    "checkAllMessage": "Ver Tudo",
    "noMessage": "Sem dados",
    "fullScreen": "Exibição em ecrã completo ",
    "ExitSystem": "Sair deste sistema",
    "back": "Retroceder",
    "top": "Topo",
    "backToTop": "Regressar ao topo",
    "homePage": "Página Principal",
    "favoriteTips": "Devido a limitação do navegador 360/Google, pressione Ctrl + D para recolher manualmente!",
    "autoSetHomeTips": "O seu navegador não suporta a definição automática da página principal; utilize o menu do navegador para definir manualmente!",
    "currentUser": "Utilizador Actual",
    "userHead": "Foto de Perfil",
    "accountPassword": "Passe da Conta",
    "change": "Actualizar",
    "head": "Foto de Perfil",
    "continueStudy": "Continuar",
    "startStudy": "Iniciar Aprendizagem"
  },
  "course": {
    "count": "geral",
    "item": "Artigo",
    "up": "Página anterior",
    "next": "Página seguinte",
    "items": "por página",
    "go": "Passar para",
    "page": "Página",
    "man": "Utilizador",
    "score": "Pontuação",
    "courseYear": "Ano",
    "courseTeachers": "Conferencista",
    "noDesc": "Sem introdução",
    "teachersDesc": "Perfil do professor",
    "checkLog": "Ver registos",
    "startStudy": "Iniciar Aprendizagem",
    "JoinLearning": "Juntar",
    "isEvaluate": "Avaliado",
    "deleteNoteButton": "Apagar",
    "closeButton": "Fechar",
    "noteSource": "De"
  },
  "onlineclass": {
    "myScore": "Minha pontuação",
    "comments": "Comentário",
    "iknow": "Eu sei",
    "detail": "Detalhe",
    "inforCertificate": "Certificado",
    "wantTalk": "Quero comentar",
    "inputTalkContent": "Digite o comentário",
    "publish": "Libertar",
    "undo": "Cancelar",
    "reply": "Responder",
    "delete": "Apagar",
    "Learned": "Concluído",
    "isDelete": "Tem a certeza que deseja apagar?",
    "submitTime": "Hora de envio",
    "to": "para",
    "download": "Descarregar"
  },
  "usercenter": {
    "htllo": "Olá",
    "welcomeMessage": "Tenha um bom dia",
    "searchTips": "Pesquise pelo curso que desejar",
    "myCertificate": "Meu Certificado",
    "startQuestionnaire": "Iniciar a resposta do trabalho",
    "empty": "nada",
    "confirmDelete": "Confirmar eliminação",
    "confirmDeleteTips": "Tem a certeza que deseja apagar?",
    "delete": "Apagar",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "Terminar aprendizagem",
    "tips": "Dicas",
    "playTips": "Dicas: Clique no botão “Terminar aprendizagem” no canto superior direito para sair. Se fechar o navegador para sair da aprendizagem, o seu tempo de aprendizagem pode não ser registado correctamente.",
    "notShowAgain": "Não lembrar novamente.",
    "gotIt": "Eu sei",
    "chapter": "Capítulo",
    "language": "língua",
    "chapterText1": "Nº",
    "chapterText2": "Capítulo",
    "note": "Notas",
    "noteBlockTitle": "Notas",
    "evaluate": "Avaliação",
    "evaluateStar": "Estrela",
    "saveEvaluate": "Enviar",
    "notePlaceholder": "Tire notas",
    "closeTips": "As alterações que realizou podem não ser guardadas",
    "closeButton": "Sair",
    "autoStop": "Parar de reproduzir automaticamente",
    "autoStopTips": "Inactividade do utilizador excedeu o tempo. Reprodução pára automaticamente.",
    "confirmOut": "Tem a certeza que deseja sair da reprodução?",
    "closeOrNot": "Fechar a janela actual",
    "noCoursePlay": "Nenhuma fonte reproduzível encontrada no curso actual",
    "attention": "Atenção por favor!"
  },
  "assessment_zlb": {
    "score": "Pontuação",
    "evalSuccess": "Avaliado"
  },
  "undefined": {}
};